import { c as _c } from "react/compiler-runtime";
import { Maybe, UploadFileEntityResponse } from "@lib/generated/graphql";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import AccordionItemBody from "./AccordionItemBody";
import AccordionItemTitle from "./AccordionItemTitle";
const AccordionItemContainer: FC<PropsWithChildren<{
  title: Maybe<string>;
  image?: Maybe<UploadFileEntityResponse>;
  className?: string;
  inverted?: boolean;
  serifClass?: string;
  onClick: VoidFunction;
  isActive: boolean;
  isTimerActive: boolean;
  autoOpenInterval?: Maybe<number>;
}>> = t0 => {
  const $ = _c(19);
  const {
    className,
    image,
    title,
    inverted,
    isActive,
    serifClass,
    onClick,
    isTimerActive,
    children,
    autoOpenInterval
  } = t0;
  const t1 = !className;
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = clsx("transition-all duration-300", className, {
      "rounded-s border border-neutral-50 relative overflow-hidden mb-2s": t1
    });
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== autoOpenInterval || $[4] !== inverted || $[5] !== isActive || $[6] !== isTimerActive || $[7] !== onClick || $[8] !== serifClass || $[9] !== title) {
    t3 = <AccordionItemTitle isTimerActive={isTimerActive} autoOpenInterval={autoOpenInterval} onClick={onClick} isActive={isActive} title={title} serifClass={serifClass} inverted={inverted}>{title}</AccordionItemTitle>;
    $[3] = autoOpenInterval;
    $[4] = inverted;
    $[5] = isActive;
    $[6] = isTimerActive;
    $[7] = onClick;
    $[8] = serifClass;
    $[9] = title;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== children || $[12] !== image || $[13] !== isActive) {
    t4 = <AccordionItemBody isActive={isActive} image={image}>{children}</AccordionItemBody>;
    $[11] = children;
    $[12] = image;
    $[13] = isActive;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default AccordionItemContainer;